// Scrap Quote Generator — standalone page mounted under /quote.
//
// Same content as the modal version (components/ui/QuoteModal); both
// wrap the shared <QuoteFlow /> component. The page adds the standard
// PageHeader + Card chrome; the modal does not.

import { PageHeader } from '../../components/ui/PageHeader/PageHeader';
import { Card } from '../../components/ui/Card/Card';
import { QuoteFlow } from './QuoteFlow';
import styles from './QuotePage.module.css';

export function QuotePage(): JSX.Element {
  return (
    <div className={styles.page}>
      <PageHeader
        title="Scrap Quote"
        subtitle="Estimate a scrap car's value and email the quote to the customer"
      />
      <Card>
        <QuoteFlow />
      </Card>
    </div>
  );
}
